import { t } from '@lingui/core/macro';
import { SwitchableChip } from '@luminovo/design-system';
import type { JSX } from 'react';
export const ApprovalSwitchableChip = ({
    isChecked,
    isLoading,
    isDisabled,
    handleClick,
}: {
    isLoading: boolean;
    isChecked: boolean;
    isDisabled?: boolean;
    handleClick: () => void;
}): JSX.Element => {
    return (
        <SwitchableChip
            checked={isChecked}
            label={t`Approve & freeze`}
            isLoading={isLoading}
            isDisabled={isDisabled}
            ContainerProps={{
                onClick: () => {
                    if (isLoading || isDisabled) {
                        return;
                    } else {
                        handleClick();
                    }
                },
            }}
        />
    );
};
